module.exports = __webpack_public_path__ + "img/12.9e648a7b.png";